const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.ffb5a3247503070fbcb3aca6c0841cbb.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.deb3b86c37daee00d6bacbb711912441.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.bbaf53bed3460208996f93e5c8871b90.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.a6a4a2917db2b851269e531c73884ef1.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.f0d2bfe6ec2f57c6fc0b0e0345ffd401.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.3f3033b805079c1045ac42f32e71ae3d.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4a0c7f4ffce8679fb4cbbab36b6704b4.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.014f2092e5ca291d7e4c65e764fc71cc.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.da21124411e1be508a907858e0a032bd.min.css',
        versioned: 'standard-tile.min.css'
    },
    standardHero: {
        hashed: 'standard-hero.f6ad5dfc6827e7e296233ae874d8e087.min.css',
        versioned: 'standard-hero.min.css'
    },
    standardBanner: {
        hashed: 'standard-banner.1e6a84867a139999021e0a29fd6c0933.min.css',
        versioned: 'standard-banner.min.css'
    },
    spinner: {
        hashed: 'spinner.62e53daf94109678466b211fec509263.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.0fd84d1a7cd0bb7887c20dfc2fee50fd.min.css',
        versioned: 'selection-set.min.css'
    },
    secondaryTile: {
        hashed: 'secondary-tile.36aa3d6aec99097576fdc5c498959a17.min.css',
        versioned: 'secondary-tile.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.58b2c0f454715e419fe9f8ae565631b0.min.css',
        versioned: 'ratings-stars.min.css'
    },
    promoBar: {
        hashed: 'promo-bar.6b7a6e41c1bf871f32cf260bfbc92600.min.css',
        versioned: 'promo-bar.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.820e616d986c8de4dbf3b1fb1e322d64.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.41318efe8ec85e451317775a1a5a8f67.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.58c5d9a2aa077c21fd319af53d5794eb.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.524bb38c814fe20dadc431a9fbf4ccf6.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.e4ca19548e932f417e4e6ebfb048113f.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.25bdd98760679cc0527ab5050643f6e5.min.css',
        versioned: 'modal-dialog.min.css'
    },
    menu: {
        hashed: 'menu.c957ebfaf590a720ccd74fb48620cb48.min.css',
        versioned: 'menu.min.css'
    },
    listbox: {
        hashed: 'listbox.6da2b447f8314a300cd43880564e8524.min.css',
        versioned: 'listbox.min.css'
    },
    legacyPopover: {
        hashed: 'legacy-popover.9e3603be64c2a4eff59723369fe5cf81.min.css',
        versioned: 'legacy-popover.min.css'
    },
    legacyModalDialog: {
        hashed: 'legacy-modal-dialog.b43ec3c0c45652af1d4b20fd87cdfe1d.min.css',
        versioned: 'legacy-modal-dialog.min.css'
    },
    legacyListbox: {
        hashed: 'legacy-listbox.0952e69b082273b828b7d18b5600f2ff.min.css',
        versioned: 'legacy-listbox.min.css'
    },
    legacyCombobox: {
        hashed: 'legacy-combobox.cb1789f3ca06194258114a6c8d0d0b19.min.css',
        versioned: 'legacy-combobox.min.css'
    },
    icon: {
        hashed: 'icon.de0c3f374d63ed3869be4238010afb64.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.3642e1e11f08825e63eb1af9f33185f1.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.ed181c9956baf9904d664d4e951ff56f.min.css',
        versioned: 'field-set.min.css'
    },
    embeddedTextHero: {
        hashed: 'embedded-text-hero.c16a5e17e2487ffc4a4c616e7111d6c9.min.css',
        versioned: 'embedded-text-hero.min.css'
    },
    detailsBanner: {
        hashed: 'details-banner.9839d0933835bce271b502dfacac8ce2.min.css',
        versioned: 'details-banner.min.css'
    },
    controlIcon: {
        hashed: 'control-icon.1be7da330ecf24ecf63997a73b5d299b.min.css',
        versioned: 'control-icon.min.css'
    },
    combobox: {
        hashed: 'combobox.e85388c3459a2c2f11199bc12d82aa3f.min.css',
        versioned: 'combobox.min.css'
    },
    carousel: {
        hashed: 'carousel.41f67104c91cac5ad062e3be50d15d0d.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.cc2ea314efd4893b304e26daec03525d.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.717ed8168e4629ce753b170c67c82886.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.1f9246f389d891f03fe55ac84d65854a.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.eb5ff24cc66dca03deb465633fafc802.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.4479f790f39649a8ba5cb8b8ad5bca21.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.fcec3eb6cd36b76cba856634a2ab7852.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
